import React, { useEffect, useState } from 'react';
import Card from '../../common/card/Card';
import dash3 from '../../common/assests/dasimg3.png';
import dash5 from '../../common/assests/dasimg5.png';
import './TotalSale.css';
import { Box, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { dashboardDataApi } from '../../api';

import MonthGraph from './MonthGraph';
import YearGraph from './YearGraph';
import dash1 from '../../common/assests/dasimg1.png';
import WeekGraph from './WeekGraph';

const TotalSales = () => {

  
  const token = useSelector((state) => state?.user?.user?.token);
  const [activeComponent, setActiveComponent] = useState(0);
  const [graphDataAll, setGraphDataAll] = useState([]);
  const [cardData, setCardData] = useState('');
  const [loading, setLoading] = useState(false);


  const handleData = async (filter) => {
    try {
      setLoading(true);
      const response = await dashboardDataApi({ token, filter });
      setLoading(false);
      setCardData(response || '');
      setGraphDataAll(response?.revenueData || []);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  
  useEffect(() => {
    handleData('week'); 
  }, [token]);

  
  const handleToggle = (index, filter) => {
    setActiveComponent(index);
    handleData(filter); 
  };

  const data = [
    { img: dash3, text1: cardData?.totalOrders || 0, text2: 'Total Orders', text3: `${cardData?.ordersGrowthPercentage || 0}%` },
    { img: dash5, text1: `$${cardData?.totalEarnings || 0}`, text2: 'Total Earnings', text3: `${cardData?.earningsGrowthPercentage || 0}%` },
    { img: dash1, text1: cardData?.totalUsers || 0, text2: 'Total Users', text3: `${cardData?.usersGrowthPercentage || 0}%` },
  ];

  return (
    <div className="row g-3 custom-row-1 mt-4">
      {/* Displaying Card Data */}
      {data.map((item, index) => (
        <div key={index} className="col-12 col-md-6 col-lg-4 col-xl-3 col-xxl-2">
          <Card data={item} />
        </div>
      ))}

  
      <div className="total-sales-container d-flex justify-content-between align-items-center flex-wrap gap-2 mt-5">
        <div style={{ color: "#362B24", fontSize: '22px', fontWeight: '500' }}>
          Total Sales
        </div>
        <div className="button-box">
          <div
            id="btn"
            style={{
              left: `${activeComponent * 33.33}%`, 
              width: `31.33%`
            }}
          ></div>
          <button
            className={`toggle-btn ${activeComponent === 0 ? 'active' : ''}`}
            onClick={() => handleToggle(0, 'week')} 
          >
            Week
          </button>
          <button
            className={`toggle-btn ${activeComponent === 1 ? 'active' : ''}`}
            onClick={() => handleToggle(1, 'month')}
          >
            Month
          </button>
          <button
            className={`toggle-btn ${activeComponent === 2 ? 'active' : ''}`}
            onClick={() => handleToggle(2, 'year')} 
          >
            Year
          </button>
        </div>
      </div>

     
      {activeComponent === 0 && <WeekGraph data={graphDataAll} />}
      {activeComponent === 1 && <MonthGraph data={graphDataAll} />}
      {activeComponent === 2 && <YearGraph data={graphDataAll} />}
    </div>
  );
};

export default TotalSales;
